"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.$supplProvisionAppdxStyleControl = exports.$supplProvisionAppdxTableControl = exports.$supplProvisionAppdxControl = exports.$appdxNoteControl = exports.$appdxFigControl = exports.$appdxFormatControl = exports.$appdxStyleControl = exports.$appdxTableControl = exports.$appdxControl = exports.$anonymSubitem10Control = exports.$anonymSubitem9Control = exports.$anonymSubitem8Control = exports.$anonymSubitem7Control = exports.$anonymSubitem6Control = exports.$anonymSubitem5Control = exports.$anonymSubitem4Control = exports.$anonymSubitem3Control = exports.$anonymSubitem2Control = exports.$anonymSubitem1Control = exports.$anonymItemControl = exports.$anonymParagraphControl = exports.$subitem10Control = exports.$subitem9Control = exports.$subitem8Control = exports.$subitem7Control = exports.$subitem6Control = exports.$subitem5Control = exports.$subitem4Control = exports.$subitem3Control = exports.$subitem2Control = exports.$subitem1Control = exports.$itemControl = exports.$paragraphControl = exports.$autoTagControl = exports.supplProvisionAppdxItemControls = exports.appdxItemControls = exports.anonymParagraphItemControls = exports.paragraphItemControls = exports.autoTagControls = void 0;
const factory_1 = __importDefault(require("../factory"));
const lexical_1 = require("./lexical");
const inline_1 = require("../../../node/cst/inline");
exports.autoTagControls = ["#"];
exports.paragraphItemControls = {
    Paragraph: ":paragraph:",
    Item: ":item:",
    Subitem1: ":subitem1:",
    Subitem2: ":subitem2:",
    Subitem3: ":subitem3:",
    Subitem4: ":subitem4:",
    Subitem5: ":subitem5:",
    Subitem6: ":subitem6:",
    Subitem7: ":subitem7:",
    Subitem8: ":subitem8:",
    Subitem9: ":subitem9:",
    Subitem10: ":subitem10:",
};
exports.anonymParagraphItemControls = {
    Paragraph: ":anonym-paragraph:",
    Item: ":anonym-item:",
    Subitem1: ":anonym-subitem1:",
    Subitem2: ":anonym-subitem2:",
    Subitem3: ":anonym-subitem3:",
    Subitem4: ":anonym-subitem4:",
    Subitem5: ":anonym-subitem5:",
    Subitem6: ":anonym-subitem6:",
    Subitem7: ":anonym-subitem7:",
    Subitem8: ":anonym-subitem8:",
    Subitem9: ":anonym-subitem9:",
    Subitem10: "anonym-subitem10:",
};
exports.appdxItemControls = {
    AppdxFig: ":appdx-fig:",
    AppdxStyle: ":appdx-style:",
    AppdxFormat: ":appdx-format:",
    AppdxTable: ":appdx-table:",
    AppdxNote: ":appdx-note:",
    Appdx: ":appdx:",
};
exports.supplProvisionAppdxItemControls = {
    SupplProvisionAppdx: ":suppl-provision-appdx:",
    SupplProvisionAppdxTable: ":suppl-provision-appdx-table:",
    SupplProvisionAppdxStyle: ":suppl-provision-appdx-style:",
};
// export const tagControls = {
//     ...paragraphItemControls,
//     ...appdxItemControls,
//     ...supplProvisionAppdxItemControls,
// };
const makeTagControlRule = (tag, control) => {
    // const control = tagControls[tag];
    const controlPtn = new RegExp(`^${control}`);
    return factory_1.default
        .sequence(s => s
        .and(r => r
        .sequence(s => s
        .and(r => r.regExp(controlPtn), "value")
        .action(({ value, range }) => ({ value, range: range() }))), "control")
        .and(r => r
        .sequence(s => s
        .and(() => lexical_1.$_, "value")
        .action(({ value, range }) => ({ value, range: range() }))), "trailingSpace")
        .action(({ control, trailingSpace }) => {
        return {
            tag,
            control: new inline_1.Control(control.value, control.range, trailingSpace.value, trailingSpace.range),
        };
    }));
};
exports.$autoTagControl = factory_1.default
    .withName("autoTagControl")
    .sequence(s => s
    .and(r => r
    .sequence(s => s
    .and(r => r.regExp(new RegExp(`^(?:${exports.autoTagControls.join("|")})`)), "value")
    .action(({ value, range }) => ({ value, range: range() }))), "control")
    .and(r => r
    .sequence(s => s
    .and(() => lexical_1.$_, "value")
    .action(({ value, range }) => ({ value, range: range() }))), "trailingSpace")
    .action(({ control, trailingSpace }) => {
    return new inline_1.Control(control.value, control.range, trailingSpace.value, trailingSpace.range);
}));
exports.$paragraphControl = makeTagControlRule("Paragraph", exports.paragraphItemControls.Paragraph);
exports.$itemControl = makeTagControlRule("Item", exports.paragraphItemControls.Item);
exports.$subitem1Control = makeTagControlRule("Subitem1", exports.paragraphItemControls.Subitem1);
exports.$subitem2Control = makeTagControlRule("Subitem2", exports.paragraphItemControls.Subitem2);
exports.$subitem3Control = makeTagControlRule("Subitem3", exports.paragraphItemControls.Subitem3);
exports.$subitem4Control = makeTagControlRule("Subitem4", exports.paragraphItemControls.Subitem4);
exports.$subitem5Control = makeTagControlRule("Subitem5", exports.paragraphItemControls.Subitem5);
exports.$subitem6Control = makeTagControlRule("Subitem6", exports.paragraphItemControls.Subitem6);
exports.$subitem7Control = makeTagControlRule("Subitem7", exports.paragraphItemControls.Subitem7);
exports.$subitem8Control = makeTagControlRule("Subitem8", exports.paragraphItemControls.Subitem8);
exports.$subitem9Control = makeTagControlRule("Subitem9", exports.paragraphItemControls.Subitem9);
exports.$subitem10Control = makeTagControlRule("Subitem10", exports.paragraphItemControls.Subitem10);
exports.$anonymParagraphControl = makeTagControlRule("Paragraph", exports.anonymParagraphItemControls.Paragraph);
exports.$anonymItemControl = makeTagControlRule("Item", exports.anonymParagraphItemControls.Item);
exports.$anonymSubitem1Control = makeTagControlRule("Subitem1", exports.anonymParagraphItemControls.Subitem1);
exports.$anonymSubitem2Control = makeTagControlRule("Subitem2", exports.anonymParagraphItemControls.Subitem2);
exports.$anonymSubitem3Control = makeTagControlRule("Subitem3", exports.anonymParagraphItemControls.Subitem3);
exports.$anonymSubitem4Control = makeTagControlRule("Subitem4", exports.anonymParagraphItemControls.Subitem4);
exports.$anonymSubitem5Control = makeTagControlRule("Subitem5", exports.anonymParagraphItemControls.Subitem5);
exports.$anonymSubitem6Control = makeTagControlRule("Subitem6", exports.anonymParagraphItemControls.Subitem6);
exports.$anonymSubitem7Control = makeTagControlRule("Subitem7", exports.anonymParagraphItemControls.Subitem7);
exports.$anonymSubitem8Control = makeTagControlRule("Subitem8", exports.anonymParagraphItemControls.Subitem8);
exports.$anonymSubitem9Control = makeTagControlRule("Subitem9", exports.anonymParagraphItemControls.Subitem9);
exports.$anonymSubitem10Control = makeTagControlRule("Subitem10", exports.anonymParagraphItemControls.Subitem10);
exports.$appdxControl = makeTagControlRule("Appdx", exports.appdxItemControls.Appdx);
exports.$appdxTableControl = makeTagControlRule("AppdxTable", exports.appdxItemControls.AppdxTable);
exports.$appdxStyleControl = makeTagControlRule("AppdxStyle", exports.appdxItemControls.AppdxStyle);
exports.$appdxFormatControl = makeTagControlRule("AppdxFormat", exports.appdxItemControls.AppdxFormat);
exports.$appdxFigControl = makeTagControlRule("AppdxFig", exports.appdxItemControls.AppdxFig);
exports.$appdxNoteControl = makeTagControlRule("AppdxNote", exports.appdxItemControls.AppdxNote);
exports.$supplProvisionAppdxControl = makeTagControlRule("SupplProvisionAppdx", exports.supplProvisionAppdxItemControls.SupplProvisionAppdx);
exports.$supplProvisionAppdxTableControl = makeTagControlRule("SupplProvisionAppdxTable", exports.supplProvisionAppdxItemControls.SupplProvisionAppdxTable);
exports.$supplProvisionAppdxStyleControl = makeTagControlRule("SupplProvisionAppdxStyle", exports.supplProvisionAppdxItemControls.SupplProvisionAppdxStyle);
//# sourceMappingURL=$tagControl.js.map